/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-useless-escape */
import React from 'react';
import router from 'next/router';
import { connect } from 'react-redux';
import Head from '@/componentWebs/head';
import page from '@/layouts/page';
import { formatNumber } from '@/utils/utils';
import { Row, Col, Select, InputNumber } from 'antd';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import EncodeUrl from '@/utils/encode';
import moment from 'moment';

const { Option } = Select;

@page
@connect(({ webs }) => ({
  webs,
}))
class Detail extends React.Component {
  static async getInitialProps(ctx) {
    const { store, dispatch, query } = ctx;
    await dispatch({
      type: 'webs/fetchArticleInfoByName',
      payload: { name: query.parentName, status: 1 },
    });
    const {
      webs: { datainfoArticle },
    } = store.getState();
    // console.log('datainfoArticle: ', datainfoArticle);
    return {
      datainfoArticle,
      query,
    };
  }

  state = {
    data: this.props.datainfoArticle,
    dataIntroduse: [],
  };

  componentDidMount() {
    const { query, dispatch } = this.props;
    const { data } = this.state;
    if (data && data.id) {
      dispatch({
        type: 'webs/fetchAllArticle',
        payload: {
          filter: {
            status: '1',
            categoriesId: data.categoriesId,
          },
          // attributes: `id,title,shortDescription,image,createDate,source,tag,author,urlSlugs`,
        },
        callback: res => {
          if (res.success) {
            if (res.result.list.length) {
              this.setState({
                dataIntroduse: (res && res.result && res.result.list) || [],
              });
            }
          }
        },
      });
    }
  }

  clickA = () => {
    const { query, dispatch } = this.props;
    // console.log('query: ', query);
    dispatch({
      type: 'webs/fetchArticleInfoByName',
      payload: { name: query.parentName, status: 1 },
      callback: res => {
        // console.log('res: ', res);
      },
    });
  };

  render() {
    const { data, dataIntroduse } = this.state;
    const { dataSite, query } = this.props;
    // console.log('data: ', data);
    // console.log('dataIntroduse: ', dataIntroduse);

    const headTitle = `${data && data.title} - ${dataSite.name}` || '';
    const { seoKeywords, seoDescriptions } = dataSite;
    const keywords = `${data.seoKeywords || data.title} ${seoKeywords}`;
    const description = `${data.seoDescriptions || data.title} - ${seoDescriptions}`;
    const ogImage = data.image && data.image[0] && data.image[0].file;
    let url;
    if (typeof window !== 'undefined') {
      url = window.location.href;
    }
    // if (!data.id || (data && data.status) === 0 || EncodeUrl(data && data.title) !== query.title) return null
    return (
      <>
        <Head
          key={data.id}
          title={headTitle}
          dataSite={dataSite}
          keywords={keywords}
          description={description}
          ogImage={ogImage}
          url={url || ''}
        />
        <section className="section-detail">
          <div className="container-normal">
            <div className="row">
              <div className="col-lg-8">
                <div className="detail-wrapper">
                  <div className="detail__content">
                    <h2 className="detail__title">{data.title}</h2>
                    <div className="ck-content" dangerouslySetInnerHTML={{ __html: data.description }} />
                  </div>
                </div>
              </div>
              <div className="col-lg-4" style={{ position: 'relative' }}>
                <div className="wrapper-relative-sticky">
                  <div className="header-detail-relative">
                    <h3 style={{ color: '#000' }}>Chính sách liên quan</h3>
                  </div>
                  <div className="chinhSachLienQuan">
                    {dataIntroduse &&
                      dataIntroduse.length > 0 &&
                      dataIntroduse.map(item => {
                        if (item.id === data.id) return null

                        return (
                          <div className="chinhSachLienQuan_item flex-a-c" key={item.id} >
                            <img src="/static/vietnamTickets/images/check.svg" style={{ marginRight: '10px' }} />
                            <a
                              href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}`}
                            >
                              {item.title}
                            </a>
                          </div>
                        )
                      })}
                  </div>
                  <div className="pagiTuyenBay-top hidden-pc" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Detail;
